// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Fvyu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2xNPo"};